/* Hallmark · component: Popover · genre: modern-minimal · theme: maeiz-tokens
 * Collision-aware: flips top/bottom/left/right to stay in viewport
 */
import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";
import { clsx } from "clsx";
import { menuContentMotionClass, overlayCollision, overlayContentMotionClass } from "../../styles/overlay";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 6, collisionPadding = overlayCollision.collisionPadding, ...props }, ref) => (
    <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            avoidCollisions={overlayCollision.avoidCollisions}
            collisionPadding={collisionPadding}
            className={clsx(
                "z-[80] w-72 rounded-xl border border-neutral-border bg-white p-4 shadow-mz-lg outline-none dark:border-white/12 dark:bg-neutral-navy",
                overlayContentMotionClass,
                className,
            )}
            {...props}
        />
    </PopoverPrimitive.Portal>
));
PopoverContent.displayName = "PopoverContent";

// re-export for consumers that need motion class on custom popovers
export { overlayContentMotionClass, menuContentMotionClass };
